import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { AppError, AUTH_ACTION_TYPE, MessageScopeType, MessageService, MessageType } from "@obg/ngx.core";
import { merge, of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { ZHH_SESSION_LIMIT_ACTION_TYPE, ZhhSessionLimitAction } from "./zhh-session-limit.action";
import { ZHH_SESSION_LIMIT_MESSAGE_CODE, ZHH_SESSION_LIMIT_MESSAGE_CONTEXT } from "./zhh-session-limit.const";
import { ZhhSessionLimitService } from "./zhh-session-limit.service";

@Injectable()
export class ZhhSessionLimitEffect {
	zhhSessionLimit$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ZHH_SESSION_LIMIT_ACTION_TYPE.get),
			switchMap(() =>
				this.service.get().pipe(
					map((response) => this.action.getSuccess(response)),
					catchError((error: AppError) => of(this.action.getFail(error)))
				)
			)
		)
	);

	sessionEnd$ = createEffect(() =>
		this.actions$.pipe(
			ofType(AUTH_ACTION_TYPE.sessionEnd),
			map(() => this.action.reset())
		)
	);

	initMessages$ = createEffect(() =>
		merge(
			this.messageService.mapClearByContext$({
				[ZHH_SESSION_LIMIT_ACTION_TYPE.get]: ZHH_SESSION_LIMIT_MESSAGE_CONTEXT.get,
			}),
			this.messageService.map$({
				[ZHH_SESSION_LIMIT_ACTION_TYPE.getSuccess]: {
					context: ZHH_SESSION_LIMIT_MESSAGE_CONTEXT.get,
					scope: MessageScopeType.Local,
					type: MessageType.Success,
					messageCode: "",
				},
				[ZHH_SESSION_LIMIT_ACTION_TYPE.getFail]: {
					context: ZHH_SESSION_LIMIT_MESSAGE_CONTEXT.get,
					scope: MessageScopeType.Local,
					type: MessageType.Error,
					messageCode: ZHH_SESSION_LIMIT_MESSAGE_CODE.getError,
				},
			})
		)
	);

	constructor(
		private actions$: Actions,
		private action: ZhhSessionLimitAction,
		private service: ZhhSessionLimitService,
		private messageService: MessageService
	) {}
}
